import type { ButtonHTMLAttributes, ReactNode, Ref } from 'react';
import styles from './EdgeHandle.module.css';

interface IEdgeHandleProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type' | 'className' | 'children'> {
  /** Icon-only, so this is the button's name. */
  'aria-label': string;
  /** Places and shapes it: the edge it sits on, its size, hover growth and motion. */
  className?: string;
  /** The icon, which grows on hover. */
  children: ReactNode;
  ref?: Ref<HTMLButtonElement>;
}

/** The half circle that pulls a panel out of a screen edge (the delivery calendar, the Monitor's fullscreen panels). */
export function EdgeHandle({ className, children, ref, ...button }: IEdgeHandleProps) {
  return (
    <button ref={ref} type="button" className={[styles.handle, className].join(' ')} {...button}>
      <span className={styles.icon}>{children}</span>
    </button>
  );
}
